import { format } from 'date-fns';

export const formatLongDateTime = (date: Date | string) => {
  return format(new Date(date), 'MMM, do yyyy, hh:mm a');
};

export const formatLongDate = (date: Date | string) => {
  return format(new Date(date), 'MMM, do yyyy');
};
